module.exports = __webpack_public_path__ + "img/austria.30efc6d.webp";